/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomFieldDefinition } from './CustomFieldDefinition';
import {
  CustomFieldDefinitionFromJSON,
  CustomFieldDefinitionFromJSONTyped,
  CustomFieldDefinitionToJSON,
} from './CustomFieldDefinition';

/**
 *
 * @export
 * @interface PaginatedCustomFieldDefinitionList
 */
export interface PaginatedCustomFieldDefinitionList {
  /**
   *
   * @type {number}
   * @memberof PaginatedCustomFieldDefinitionList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomFieldDefinitionList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomFieldDefinitionList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<CustomFieldDefinition>}
   * @memberof PaginatedCustomFieldDefinitionList
   */
  results: Array<CustomFieldDefinition>;
}

/**
 * Check if a given object implements the PaginatedCustomFieldDefinitionList interface.
 */
export function instanceOfPaginatedCustomFieldDefinitionList(
  value: object,
): value is PaginatedCustomFieldDefinitionList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedCustomFieldDefinitionListFromJSON(json: any): PaginatedCustomFieldDefinitionList {
  return PaginatedCustomFieldDefinitionListFromJSONTyped(json, false);
}

export function PaginatedCustomFieldDefinitionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCustomFieldDefinitionList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(CustomFieldDefinitionFromJSON),
  };
}

export function PaginatedCustomFieldDefinitionListToJSON(value?: PaginatedCustomFieldDefinitionList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(CustomFieldDefinitionToJSON),
  };
}
